import { GeneralModel } from "./general.model";

export class ShipmentContract extends GeneralModel {
    contractTypeId?: number;
    shipmentId?: number;
    companyNameA?: string;
    companyAddressA?: string;
    companyPhoneA?: string;
    taxCodeA?: string;
    representA?: string;
    representRoleA?: string;
    companyNameB?: string;
    companyAddressB?: string;
    companyPhoneB?: string;
    faxNumberB: string;
    taxCodeB?: string;
    accountNumber?: string;
    representB?: string;
    representRoleB?: string;
    advancePayment?: number;
    advancePaymentType?: any;
    lastPayment?: number;
    lastPaymentType?: string;
    header?: string;
    identityCardA?: number;
    placeOfIssue?: string;
    dateOfIssue?: any;
    isPersonal?: boolean;
    contractPersonalTypeId?: number;
    legalId? : number
    note:string;
}